import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const breadcrumbs: BreadcrumbItem[] = [
    { label: '首页', href: '/' },
  ];

  if (pathSegments[0] === 'category') {
    const categorySlug = pathSegments[1];
    const categoryNames: Record<string, string> = {
      all: '全部漫画',
      romance: '恋爱漫画',
      fantasy: '奇幻漫画',
      action: '动作漫画',
      mystery: '悬疑漫画',
      comedy: '搞笑漫画',
      drama: '剧情漫画',
      school: '校园漫画',
      historical: '古风漫画',
    };
    breadcrumbs.push({
      label: '分类浏览',
      href: '/category/all',
    });
    if (categorySlug && categoryNames[categorySlug]) {
      breadcrumbs.push({ label: categoryNames[categorySlug] });
    }
  } else if (pathSegments[0] === 'manga') {
    breadcrumbs.push({
      label: '分类浏览',
      href: '/category/all',
    });
    breadcrumbs.push({ label: '漫画详情' });
  } else if (pathSegments[0] === 'about') {
    breadcrumbs.push({ label: '关于我们' });
  }

  if (breadcrumbs.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="pt-20 pb-4 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <ol className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
          {breadcrumbs.map((crumb, index) => (
            <li key={index} className="flex items-center gap-2">
              {index > 0 && (
                <span className="w-3 h-3 flex items-center justify-center text-foreground-300">
                  <i className="ri-arrow-right-s-line text-[10px]"></i>
                </span>
              )}
              {crumb.href ? (
                <Link to={crumb.href} className="hover:text-primary-500 transition-colors no-underline">
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-foreground-700 font-medium">{crumb.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}